import * as React from "react";
import { Form, Input, InputOnChangeData } from "semantic-ui-react";

export type NumberFieldProps = {
  label?: string;
  value: number;
  isError: boolean;
  errorMessage?: string;
  disabled?: boolean;
  readonly?: boolean;
  onChange: (value: number) => void;
  id: string;
  minValue?: number | string;
};

function NumberField({
  label = "",
  value,
  isError,
  errorMessage = "",
  readonly= false,
  disabled = false,
  onChange,
  id,
  minValue = 0
}: NumberFieldProps): JSX.Element {
  return (
    <>
      <Form.Field
        id={id}
        className="edit-number-property"
        control={Input}
        label={label}
        type="number"
        error={isError}
        value={value ? value.toString() : 0}
        disabled={disabled}
        readOnly={readonly}
        // eslint-disable-next-line
        onChange={({}, data: InputOnChangeData) => {
          onChange(Number(data.value));
        }}
        onPaste={(evt : InputOnChangeData) => evt.preventDefault()}
        onKeyDown={(evt : InputOnChangeData) => {
          let restrictedSym;
          if(minValue === 0 || minValue === "0") {
           restrictedSym = ["e", "E", "+", "-", "."];
          } else {
           restrictedSym = ["e", "E", "+","."];
          }
          if (id === "Extrascaling") {
            restrictedSym.splice(restrictedSym.indexOf("."), 1);
          }
          restrictedSym.includes(evt.key) && evt.preventDefault();
        }}
        min = {minValue}
      />
      {(isError && errorMessage) && <p className="errorMessageMargin">{errorMessage}</p>}
    </>
  );
}

export default NumberField;
